// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-select.select-disabled {
  opacity: 1;
}

.item-interactive-disabled:not(.item-multiple-inputs) .sc-ion-label-ios-h,
.item-interactive-disabled:not(.item-multiple-inputs) .sc-ion-label-android-h {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/global/create-electrical-measurement/create-electrical-measurement-detail/create-electrical-measurement-detail.page.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;;AAGA;;EAEE,UAAA;AAAF","sourcesContent":["ion-select.select-disabled {\n  opacity: 1;\n}\n\n\n.item-interactive-disabled:not(.item-multiple-inputs) .sc-ion-label-ios-h,\n.item-interactive-disabled:not(.item-multiple-inputs) .sc-ion-label-android-h {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
